export class MarginModel {
cmbMargin: string;
setValue(res){
if(res){
if(res['cmbMargin']){this.cmbMargin = res['cmbMargin'];}
}
}
}